import { FC } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { VideoPlayer } from '@/shared/components/VideoPlayer';
import { COLORS } from '@/shared/constants/colors';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { useModalsStore } from '@/widgets/modals/modals.store';

type VideoPlayerModalProps = {
  video: {
    src: string;
    type: string;
  };
};

export const VideoPlayerModal: FC<VideoPlayerModalProps> = ({ video }) => {
  const isDesktopLayout = useIsDesktop();
  const modals = useModalsStore();

  return (
    <StyledModal
      open
      centered
      footer={null}
      width={isDesktopLayout ? 1120 : undefined}
      height={isDesktopLayout ? 630 : undefined}
      onCancel={modals.closeModal}
    >
      <VideoPlayer
        options={{
          autoplay: true,
          controls: true,
          muted: false,
          preload: 'auto',
          sources: [video],
          fluid: true,
          enableSmoothSeeking: true,
          aspectRatio: '16:9',
        }}
      />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-close {
      background: ${COLORS.systemLight200};
      border-radius: 50%;
      top: 24px;
      right: 24px;
      width: 24px;
      height: 24px;
    }

    .ant-modal-content {
      padding: 0;
      border-radius: 12px;
      overflow: hidden;
    }

    ${media.mobile} {
      max-width: 100%;
      width: 100% !important;
      margin: 0;

      .ant-modal-content {
        border-radius: 0;
      }

      &,
      & > div,
      .ant-modal-content,
      .ant-modal-body {
        height: 100%;
      }
    }
  }
`;
